// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2b0-f","container":"styles_container__3hcws","title":"styles_title__hUUsB","wrapper":"styles_wrapper__2YCOm","answer":"styles_answer__GyTGI"};